export default __webpack_public_path__ + "static/media/jangwon_nft_9.0253fa0f.svg";